import dayjs from "dayjs"
import { T点検整備Item } from "./TenkenSeibiList"

/**
 * 予定月フラグを作成する関数
 * @param i - 点検整備アイテム
 * @param element - 月の要素（1-12）
 * @param 年 - 年の文字列
 * @returns 予定月と予定車検月のフラグ
 */
export const create予定月フラグ = (i: T点検整備Item, element: number, colDate: string) => {
  // 作成するColumnに紐づく日付データがある場合、targetに設定する
  i.点検整備リスト.find((item) => {
    let m = parseInt(dayjs(item.点検整備予定日).format("MM"))
    return element === m
  })

  // 車検予定の自動設定用変数を設定
  // 車検満了日＞登録年月日の優先度で使用する
  // ※※　車検満了日は車検日の１年後の日付の為、予定日は逆算で求める
  const 車検満了日 = i.車検満了日
  const 登録年月日 = i.登録年月日
  // 基準日から算出した予定日を格納する変数　3~9: 3ヵ月点検, 12: 車検（年次）
  let before_3_month
  let before_6_month
  let before_9_month
  let after_3_month
  let after_6_month
  let after_9_month
  let after_12_month
  // ３か月点検の予定フラグ
  let 予定月
  // 年次の車検予定フラグ
  let 予定車検月

  // 条件判定により予定フラグを設定する
  if (車検満了日) {
    // 前回実施日(車検満了日)から算出する場合

    // 前回実施日から３か月区切りを算出（減算）
    before_3_month = dayjs(車検満了日).subtract(9, "M")
    before_6_month = dayjs(車検満了日).subtract(6, "M")
    before_9_month = dayjs(車検満了日).subtract(3, "M")
    // 車検
    after_12_month = 車検満了日
    // 前回実施日から３か月区切りを算出（減算）
    after_3_month = dayjs(車検満了日).add(3, "M")
    after_6_month = dayjs(車検満了日).add(6, "M")
    after_9_month = dayjs(車検満了日).add(9, "M")

    // 設定中のColumnと紐づく日付があるか判定
    if (
      colDate === dayjs(before_3_month).format("YYYY/MM") ||
      colDate === dayjs(before_6_month).format("YYYY/MM") ||
      colDate === dayjs(before_9_month).format("YYYY/MM") ||
      colDate === dayjs(after_3_month).format("YYYY/MM") ||
      colDate === dayjs(after_6_month).format("YYYY/MM") ||
      colDate === dayjs(after_9_month).format("YYYY/MM")
    ) {
      // 3~9ヵ月の場合、予定フラグを設定
      予定月 = true
    } else if (colDate === dayjs(after_12_month).format("YYYY/MM")) {
      // 12ヵ月の場合、
      予定車検月 = true
    }
  } else {
    // 車輌の登録年月から３か月区切りを算出(加算)
    before_3_month = dayjs(登録年月日).add(3, "M")
    before_6_month = dayjs(登録年月日).add(6, "M")
    before_9_month = dayjs(登録年月日).add(9, "M")
    // 車検
    after_12_month = dayjs(登録年月日).add(12, "M")

    // 年月の判定
    if (
      colDate === dayjs(before_3_month).format("YYYY/MM") ||
      colDate === dayjs(before_6_month).format("YYYY/MM") ||
      colDate === dayjs(before_9_month).format("YYYY/MM")
    ) {
      // 3~9ヵ月の場合、予定フラグを設定
      予定月 = true
    } else if (colDate === dayjs(after_12_month).format("YYYY/MM")) {
      // 12ヵ月の場合、
      予定車検月 = true
    }
  }

  return {
    予定月: 予定月,
    予定車検月: 予定車検月,
  }
}
